var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[_c('div',{staticClass:"size-contral"},[_c('div',{staticClass:"square-box"},[_c('img',{attrs:{"src":_vm.url}})])]),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }